import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Dropdown } from '@core/models/dropdown.model';
import { MerchantBank } from '@core/models/merchant-bank.model';

@Injectable()
export class MerchantBankHttpServiceV2 {
  constructor(private http: HttpClient) {}

  getMerchantBankAccounts(params?: string): Observable<Dropdown[]> {
    return this.http
      .get<ApiResponse>(`/merchantbank/v2?paginate=false${params || ''}`)
      .pipe(map((res) => res.data.rows));
  }
}
